import { render, staticRenderFns } from "./MasterDataSync.vue?vue&type=template&id=dd283f9a"
import script from "./MasterDataSync.vue?vue&type=script&lang=js"
export * from "./MasterDataSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports